module.exports = __webpack_public_path__ + "static/media/web-app.8d65aef6.jpg";